import { Link } from 'gatsby'
import React from 'react'
import { usePathPrefix } from '../../hooks/usePathPrefix'

const FooterLiftStorys = ({ title, slug, featureImage, isMobile }) => {
  const pathPrefix = usePathPrefix()

  return (
    <div
      className={`flex-1 lg:pr-16 mt-5.5 md:mt-0 xl:mt-5.5 mb-11 lg:mb-0 ${
        isMobile ? 'xl:hidden' : 'hidden xl:block'
      }`}
    >
      <div className="mb-5.5 flex">
        <Link
          to={`${pathPrefix}/lift-storys`}
          className="italic font-bold text-black underline text-[15px] transition-colors hover:text-red-as"
        >
          Lift Storys
        </Link>
      </div>
      <div className="flex items-center xl:block">
        <div className="flex-shrink-0 w-1/2 xl:w-full">
          <img
            src={featureImage?.small_url}
            alt={title}
            className="w-full h-auto rounded shadow-tpmp lg:shadow-dp"
          />
        </div>
        <div className="w-1/2 pl-4 italic font-medium xl:pl-0 xl:pt-4 xl:w-full">
          <h2 className="text-lg">
            <Link
              to={`${pathPrefix}/lift-storys/${slug}`}
              className="underline transition-colors hover:text-red-as"
            >
              {title}
            </Link>
          </h2>
        </div>
      </div>
    </div>
  )
}

export default FooterLiftStorys
